import React from 'react';
import proptypes from 'prop-types';
const { object, string, number, oneOfType } = proptypes;
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Price } from '@thd-olt-component-react/price';
import { Placeholder } from '@thd-olt-component-react/core-ui';
import { Badge } from '@one-thd/sui-atomic-components';
import {
  EXPERIENCE_TAGS as PROMO_EXPERIENCE_TAGS
} from '@thd-olt-component-react/promotion-products/dist/utils/constants';

const ChoicePrice = ({ graphProduct, promoType, sku }) => {
  if (!graphProduct) {
    return (<Placeholder width="100%" height="40px" />);
  }

  if (!graphProduct?.pricing?.value) {
    return (
      <div className={
        promoType === PROMO_EXPERIENCE_TAGS.BMSM
          ? 'sui-flex sui-justify-center custom-price bmsm'
          : 'sui-flex sui-justify-center custom-price'
      }
      >
        <Badge size="small" variant="regular" color="danger">Null Price</Badge>
      </div>
    );
  }

  const hasUnitPricing = !!graphProduct?.pricing?.alternate?.unit?.value;

  return (
    <QueryProvider
      dataSource="catalog"
      cacheKey="choice-price"
      skip={() => true}
    >
      <div className={[
        'custom-price',
        'choice-price',
        promoType === PROMO_EXPERIENCE_TAGS.BMSM ? 'bmsm' : '',
        hasUnitPricing ? 'has-unit-price' : '',
      ].filter(Boolean).join(' ')}
      >
        <Price
          channel="mobile"
          itemId={sku}
          large={false}
          skip
          displayEachUom={false}
          hideLimitPerOrder
          clsRemediation={{
            placeholders: true,
            preservePlaceholders: true
          }}
          product={graphProduct}
        />
      </div>
    </QueryProvider>
  );
};

ChoicePrice.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  graphProduct: object,
  promoType: string,
  sku: oneOfType([string, number]).isRequired
};

ChoicePrice.defaultProps = {
  graphProduct: null,
  promoType: ''
};

export default ChoicePrice;
